import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from 'react-bootstrap';
import { Clear } from 'material-react-icons';
import { MODAL_TITLE } from '../../../constants/labels';

import './PaymentCalculatorModal.scss';
import PaymentCalculatorController from '../../../containers/PaymentCalculatorController';

class PaymentCalculatorModal extends Component {
	render() {
		const { show, handleHide } = this.props;

		return (
			<Modal show={show} className="pc-modal">
				<Modal.Header>
					<Modal.Title>{MODAL_TITLE}</Modal.Title>
					<Button onClick={handleHide} className="pc-close">
						<Clear />
					</Button>
				</Modal.Header>

				<Modal.Body>
					<PaymentCalculatorController />
				</Modal.Body>
			</Modal>
		);
	}
}

PaymentCalculatorModal.propTypes = {
	show: PropTypes.bool.isRequired,
	handleHide: PropTypes.func.isRequired
};

export default PaymentCalculatorModal;



// WEBPACK FOOTER //
// ./src/components/views/loaded/PaymentCalculatorModal.jsx